export default {
domainInvalid: {
  siteUnavailableTitle: "साइट उपलब्ध नहीं है",
  siteUnavailableDesc: "यह साइट अभी उपलब्ध नहीं है।",
  contactAdmin: "कृपया व्यवस्थापक से संपर्क करें।",
  serverErrorTitle: "सेवा उपलब्ध नहीं है",
  serverErrorDesc: "सर्वर से कनेक्ट नहीं हो सका, कृपया बाद में पुनः प्रयास करें।",
  serverErrorTip: "सर्वर के वापस आते ही यह स्वतः पुनः कनेक्ट हो जाएगा।",
  notAuthorizedTitle: "डोमेन अधिकृत नहीं है",
  notAuthorizedDesc: "वर्तमान डोमेन को इस सेवा तक पहुँचने की अनुमति नहीं है।",
  checking: "जाँच हो रही है...",
  retry: "पुनः प्रयास करें",
  reload: "पुनः लोड करें",
  reloading: "पुनः लोड हो रहा है...",
  checkingDomain: "डोमेन की जाँच हो रही है...",
  authorizedRedirecting: "डोमेन अधिकृत है, पुनर्निर्देशित किया जा रहा है...",
  stillNotAuthorized: "डोमेन अभी भी अधिकृत नहीं है",
  reconnecting: "पुनः कनेक्ट हो रहा है..."
}
};
